import React from "react";
import { Trans } from "../utils/i18n";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import RadioButton from "./RadioBig";
import {usePage} from "@inertiajs/inertia-react";
import {trackConversion} from "../utils/analytics";
import { useGetProductCategories } from '../hooks/useOrderProductCategories';

export const ProductCategorySelect = React.memo(function ({ values, mode, form, productValues, amountOptions, fetchWithProducts}) {
        const orderEntryDispatch = useFormStateDispatch();
        const { categories, selectedCategory, } = useFormState();
        const { defaultCategory } = usePage().props;
        useGetProductCategories({
            ...(!fetchWithProducts && {
                noProducts: true,
            }),
        }, {
            onSuccess: (response) => {
                orderEntryDispatch({ type: 'setCategories', value: response.categories });
                if(defaultCategory && !selectedCategory) {
                    const category = response.categories.find(item => item.id === Number(defaultCategory));
                    if(category) {
                        orderEntryDispatch({ type: 'setSelectedCategory', value: category });
                    }
                }
            }
        });

        if (!categories) {
            return <div><Trans i18nKey="productSelect.loading">Loading</Trans></div>;
        }

        return (
            <div>
                <div className={'grid grid-cols-10 gap-6 mt-6'}>
                    {
                        categories
                            .map((category) =>
                                <div className={'col-span-5 md:col-span-2'} key={category.id}>
                                    <RadioButton
                                        input={{
                                            checked: selectedCategory?.id === category.id,
                                            value: category.id,
                                            onChange: (e) => {
                                                // Reset serial number because it's not valid for the new category
                                                orderEntryDispatch({type: 'setSerialNumber', value: {}});
                                                orderEntryDispatch({type: 'setSelectedCategory', value: category});
                                                form.change('problem_1', null);
                                                form.change('problem_2', null);
                                                form.change('otherProduct', null);
                                                orderEntryDispatch({type: 'setOtherProductConversionButton', value: false});
                                                trackConversion({
                                                    action: 'OrderEntryClickCategory:'+(category.id),
                                                });
                                            },
                                        }}
                                        field={{
                                            titel: category.description,
                                            image: category.image,
                                        }}
                                        meta={{}}
                                    />
                                </div>,
                            )
                    }
                </div>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

